import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {MeService} from '../../../../services/api/me.service';
import {LoginService} from '../../../../services/api/login.service';
import {User} from '../../../../data/models/user';

@Component({
  selector: 'app-bar',
  templateUrl: './bar.component.html',
  styleUrls: ['./bar.component.css']
})
export class BarComponent implements OnInit {

  public me: User | null = null;
  @Output() toggleMenu = new EventEmitter<void>();

  constructor(private meService: MeService,
              private loginService: LoginService) {
    this.meService.me$.subscribe(me => {
      this.me = me;
    });
  }

  ngOnInit(): void {
  }

  formatFullFio(): string {
    let fio = '';
    if (this.me) {
      if (this.me.surname) {
        fio = this.me.surname;
      }
      if (this.me.name && this.me.name.length > 0) {
        if (fio.length > 0) {
          fio += ' ';
        }
        fio += this.me.name;
      }
      if (this.me.patronymic && this.me.patronymic.length > 0) {
        if (fio.length > 0) {
          fio += ' ';
        }
        fio += this.me.patronymic;
      }

    }
    return fio;
  }

  formatFio(): string {
    let fio = '';
    if (this.me) {
      if (this.me.surname) {
        fio = this.me.surname;
      }
      if (this.me.name && this.me.name.length > 0) {
        if (fio.length > 0) {
          fio += ` ${this.me.name.charAt(0)}.`;
        } else {
          fio = this.me.name;
        }
      }
      if (this.me.patronymic && this.me.patronymic.length > 0) {
        if (fio.length > 0) {
          fio += ` ${this.me.patronymic.charAt(0)}.`;
        } else {
          fio = this.me.patronymic;
        }
      }
    }
    return fio;
  }

  onMenuClick(): void {
    this.toggleMenu.emit();
  }

  logout(): void {
    this.loginService.logout();
  }

}
